import { useViewport } from "../../../components/ReactContext_Viewport";

import AreaOfInterest from "./AreaOfInterest";
import SelectedGeos from "./SelectedGeos";
import DownloadButton from "./DownloadButton";

const LeftPane = () => {
    const { screenSize } = useViewport();

    if (screenSize === "mobile") return null;
    return (
        <>
            <AreaOfInterest />
            <SelectedGeos />
            <DownloadButton />
        </>
    );
};
export default LeftPane;
